@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.button {
    composes: roundButton from "../../styles/buttons.module.scss";
}
